module.exports = "<footer id=\"footer\">\r\n  <div class=\"bar\">\r\n    <span>© {{year}} {{env.appName}}</span>\r\n    </div>\r\n</footer>\r\n"